import { Component, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-resto-publish-info-popup',
  templateUrl: './resto-publish-info-popup.component.html',
  styleUrls: ['./resto-publish-info-popup.component.scss']
})
export class RestoPublishInfoPopupComponent {
  @ViewChild('restoPublishModal') restoPublishTemplate!: TemplateRef<RestoPublishInfoPopupComponent>;
}
